import { ICrudEntity } from '../interfaces/ICrudEntity';

export class CrudEntityCancel implements ICrudEntity {
  uid: string = 'cancel';  
}
